import {
  SET_RESOLUTION_FILTERS,
  RESET_RESOLUTION_FILTERS,
  SET_RESOLUTION_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setResolutionFilters = filters => ({
  type: SET_RESOLUTION_FILTERS,
  filters,
});

export const cleanResolutionFilters = () => ({
  type: RESET_RESOLUTION_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_RESOLUTION_GRID_SORT_CRITERIA,
  sortCriteria,
});
